export const API_URL = "https://api.nicesoftwaresolutions.com/";


